import { render, staticRenderFns } from "./SharedInbox.vue?vue&type=template&id=9b8604ae&scoped=true&"
import script from "./SharedInbox.vue?vue&type=script&lang=js&"
export * from "./SharedInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8604ae",
  null
  
)

export default component.exports